var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    transform: "translate(0.5)",
    fill: "#FFEEE8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M40.5 25C37.5333 25 34.6332 25.8797 32.1665 27.528C29.6997 29.1762 27.7771 31.5189 26.6418 34.2597C25.5065 37.0006 25.2094 40.0166 25.7882 42.9264C26.367 45.8361 27.7956 48.5088 29.8934 50.6066C31.9912 52.7044 34.6639 54.133 37.5737 54.7118C40.4834 55.2906 43.4994 54.9935 46.2403 53.8582C48.9811 52.7229 51.3238 50.8003 52.972 48.3336C54.6203 45.8668 55.5 42.9667 55.5 40C55.5 38.0302 55.112 36.0796 54.3582 34.2597C53.6044 32.4399 52.4995 30.7863 51.1066 29.3934C49.7137 28.0005 48.0602 26.8956 46.2403 26.1418C44.4204 25.388 42.4698 25 40.5 25ZM38 45V35L45.5 40L38 45Z",
    fill: "#FF6636"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 55C48.7843 55 55.5 48.2843 55.5 40C55.5 31.7157 48.7843 25 40.5 25C32.2157 25 25.5 31.7157 25.5 40C25.5 48.2843 32.2157 55 40.5 55Z",
    stroke: "#FF6636",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5 40L38 35V45L45.5 40Z",
    stroke: "#FF6636",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.52246df935e205269189ea377037c08e.svg";
export { ForwardRef as ReactComponent };